/** @import modules */

import { useTranslation }           from "react-i18next";

import { useParams, useNavigate }   from "react-router-dom";

/** @import hooks */

import { RimsNavigator }            from "../../../../../Hooks/RimsNavigator";

/** @import components */

import SearchableSelect             from "../../../../Shared/SearchableSelect";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns Offset filter component
 * 
 */

const Offset = ( { attributes } ) => { const 

    { t }               = useTranslation    (),

    navigate            = useNavigate       (),

    { parameters }      = useParams         (),

    Filter = ( value ) => { const 

        object = { f : 12, l: null, a: null, b: null, o: ( value === "default" ) ? null : value, loc: window.pageYOffset };

        return navigate (  
            
            `/shop/rims/${
            
                new URLSearchParams ( RimsNavigator ( parameters, object ) ).toString () }` );

    };

    /** @return component */

    return ( <div className="content manufacturers">

        <label className="select shadow-select">

            <SearchableSelect
                options={ attributes }
                value={ new URLSearchParams ( parameters ).get ( "o" ) || "default" }
                onChange={ Filter }
                type="INT"
                label={ t ( "select_option" ) }
            />

        </label>

    </div> );

}

/** @export Offset */
 
export default Offset;